<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="map-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <base-map
                        :markers="formattedMarkers"
                        ref="baseMap"
                    >
                        <basic-map-popover
                            v-for="marker in formattedMarkers"
                            :key="marker.id"
                            :slot="`marker_info_window_${ marker.id }`"
                            :title="marker.title"
                            :address="marker.address"
                            :text="marker.text"
                        />
                    </base-map>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import BasicMapPopover from '../../molecules/BasicMapPopover/BasicMapPopover.vue';
    import BaseMap from '../../molecules/BaseMap/BaseMap.vue';

    export default {
        name: 'map-section',

        components: { BasicMapPopover, BaseMap },

        props: {
            markers: {
                type: Array,
                default: () => ([]),
            },
        },

        computed: {
            /**
             * Format the markers data for the popover.
             *
             * @returns {Array}
             */
            formattedMarkers() {
                return this.markers
                    .filter(({ lat, lng }) => lat !== null && lng !== null)
                    .map(({ address, postcode, ...marker }) => ({
                        ...marker,
                        address: `${ address }, ${ postcode }`,
                    }));
            },
        },
    };
</script>
